import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import {Navigation} from 'swiper/modules'

import PDComponent from '../../pd-component'

export const CategoryQuickLinks = ({regions}) => {
    const totalCards = regions.reduce(
        (acc, region) =>
            acc +
            (region?.components?.filter((component) => component?.data?.primaryImage)?.length || 0),
        0
    )

    if (!totalCards) {
        return null
    }

    return (
        <Box
            width={{
                base: '100vw',
                lg: 'calc(100vw - var(--scrollbar-width))'
            }}
            sx={{
                '.swiper': {
                    paddingRight: {base: '20px', lg: '60px'},
                    paddingTop: '47px',

                    '&:not(.swiper-initialized)': {
                        paddingRight: 0,

                        '.swiper-wrapper': {
                            display: 'flex',
                            overflowX: 'auto',
                            gap: '10px'
                        },
                        '.swiper-slide': {
                            flex: '0 0 200px'
                        }
                    }
                },
                '.swiper-wrapper': {
                    paddingLeft: {base: '20px', lg: '60px'},
                    marginRight: {base: '-20px', lg: '-60px'}
                },
                '.swiper-slide': {
                    width: '200px',

                    '&:last-child': {
                        marginRight: {
                            base: '20px !important',
                            lg: '60px !important'
                        }
                    }
                }
            }}
        >
            <Swiper
                navigation={true}
                modules={[Navigation]}
                slidesPerView={'auto'}
                spaceBetween={10}
            >
                {regions?.map((region) =>
                    region?.components?.map((component, index) => (
                        <SwiperSlide key={`${region.id}-${index}`}>
                            <PDComponent
                                component={component}
                                textColor
                                titleFontSize={
                                    component.data.titleFontFamily == 'body' ? '14px' : '15px'
                                }
                                titleFontWeight={
                                    component.data.titleFontFamily == 'body' ? '300' : '400'
                                }
                            />
                        </SwiperSlide>
                    ))
                )}
            </Swiper>
        </Box>
    )
}

CategoryQuickLinks.propTypes = {
    regions: PropTypes.array
}

export default CategoryQuickLinks
